import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {take} from 'rxjs/operators';
import {DialogService} from '@shared/services/dialog-service';

@Component({
    standalone: false,
    selector: 'app-exclude-test-companies',
  templateUrl: './exclude-test-companies.component.html',
  styleUrl: './exclude-test-companies.component.scss'
})
export class ExcludeTestCompaniesComponent implements OnInit, OnDestroy {
  isAdding = false;
  newItem = '';
  @Input() items: string[] = [];

  inputForm: FormGroup;

  constructor(private commandService: CommandService,
              private snackBarService: SnackBarService,
              private formBuilder: FormBuilder,
              private fuseSplashScreenService: FuseSplashScreenService,
              private dialogService: DialogService) {
  }

  ngOnInit() {
    this.inputForm = this.formBuilder.group({
      companyId: ['', Validators.required]
    });
  }
  ngOnDestroy(): void {
  }

  showInputField() {
    this.isAdding = true;
  }

  addCompany() {
    const companyId = this.inputForm.controls.companyId.value?.trim();
    const platformCommand = new PlatformCommand('AddSupportTestCompanyCommand', Api.TaskManager);
    platformCommand.setValue('CompanyId', companyId);

    this.fuseSplashScreenService.show();
    this.commandService.executePlatformCommand(platformCommand).pipe(take(1)).subscribe(
      response => {
        this.fuseSplashScreenService.hide();
        if (response && response.fieldValues && response.fieldValues['Added'] === true) {
          this.snackBarService.showInformation('Company Added Successfully!', 1800);
          this.items.push(companyId);
          this.isAdding = false;
          this.inputForm.controls.companyId.reset();
        }
      }, err => {
        this.fuseSplashScreenService.hide();
        console.log(err);
      });
  }

  cancel() {
    this.inputForm.controls.companyId.reset();
    this.isAdding = false;
  }

  removeCompany(companyId: string) {
    const title = 'Confirmation';
    const message = `Are you sure want to remove ${companyId}?`;
    this.dialogService.showConfirmDialog(title, 'Yes', 'No', message, '')
      .pipe(take(1)).subscribe(dialogResponse => {
      if (dialogResponse.action === 'OK') {
        const command = new PlatformCommand('RemoveSupportTestCompanyCommand', Api.TaskManager);
        command.setValue('CompanyId', companyId);

        this.fuseSplashScreenService.show();
        this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(
          response => {
            this.fuseSplashScreenService.hide();
            if (response && response.fieldValues && response.fieldValues['Removed'] === true) {
              this.snackBarService.showInformation('Company Removed Successfully!', 1800);
              this.items = this.items.filter(x => x !== companyId);
            }
          }, err => {
            this.fuseSplashScreenService.hide();
            console.log(err);
          });
      }
    });
  }
}
